export default __webpack_public_path__ + "static/media/rf-ico.ed4b3d23.svg";